import { formHelperTextClasses, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const DrivingIncidentsModalToggleButtonsGroupTitleStyle: StyleExtend<Theme> = {
  mt: 4,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  [`.${formHelperTextClasses.root}`]: {
    m: '3px 0px 0px 0px',
    color: (theme) => theme.palette.error.main,
  },
};

export const DrivingIncidentsModalToggleButtonsGroupDividerStyle: StyleExtend<Theme> = {
  mt: 1.5,
};

export const DrivingIncidentsModalDriverSelectStyle: StyleExtend<Theme> = {
  overflow: 'hidden',
  maxWidth: '640px',
};

export const DrivingIncidentsModalDriverSelectMenuItemStyle: StyleExtend<Theme> = {
  '&>span:first-of-type': (theme) =>
    theme.mixins.textOverflowStyle({
      xs: '100%',
      sm: '602px',
    }),
};
